<template>
  <div class="rooms">
    <div class="rooms_form">
      <form @submit.prevent='onSubmit'>
        <div class="rooms_formWrapper">
          <input type="text" v-model="roomName" class="rooms_textField"/>
          <input type="submit" value="部屋作成" class="rooms_submit">
        </div>
      </form>
    </div>
    <div v-if="rooms.length > 0">
      <ul>
        <li v-for="room in rooms" class="rooms_listItem">
          <router-link v-bind:to="{ name: 'Room', params: { id: room.id }}" class="rooms_listItemLink">
            <div class="rooms_listItem--left">
              <div class="rooms_pic">
                <img :src=room.data.account.pictureSrc></img>
              </div>
              <div class="rooms_name">
                {{room.data.name}}
                <!-- <router-link v-bind:to="{ name: 'Room', params: { id: room.id }}">{{room.data.name}}</router-link> -->
              </div>
            </div>
            <div class="rooms_listItem--right">
              <div class="rooms_limitTime">
                <div>{{limitTime(room)}}h前</div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div v-if="rooms.length == 0 && !isLaunching">
      <div>周辺の部屋が見つかりませんでした。</div>
      <div>最初に作ってみましょう！</div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import 'firebase/firestore'

export default {
  name: 'Rooms',
  data () {
    return {
      rooms: [],
      roomName: '',
      isLaunching: true
    }
  },
  methods: {
    onSubmit: function(){
      if (!this.roomName) return
      store.getters.firebase.firestore().collection("room").add(
        {
          name: this.roomName,
          _createdAt: Date.now(),
          messages: {},
          location: new store.getters.firebase.firestore.GeoPoint(store.getters.location.latitude, store.getters.location.longitude),
          account: { ...store.getters.currentAccount  },
        }
      )
      .then(docRef => {
        this.roomName = ''
      })
      .catch(e => alert(e))
    },
    limitTime: function(room) {
      return 24 - Math.ceil(((- Date.now() + room.data._createdAt + 86400000) / 1000 / 60 / 60))
    }
  },
  created() {
    // .where("_createdAt", ">=", Date.now() - 86400000)
    store.getters.firebase.firestore().collection("room").where("_createdAt", ">=", Date.now() - 86400000).onSnapshot(querySnapshot => {
      const object = this
      querySnapshot.docChanges().forEach(function(change) {
        if (change.type === "added") {
          const lat1 = change.doc.data().location.latitude * Math.PI / 180;
          const lng1 = change.doc.data().location.longitude * Math.PI / 180;
          const lat2 = store.getters.location.latitude * Math.PI / 180;
          const lng2 = store.getters.location.longitude * Math.PI / 180;
          const distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
          if(distance < 0.5) {
            object.rooms.push({id: change.doc.id, data: change.doc.data()})
          }
        }
        if (change.type === "removed" || change.type === "modified") {
          console.log('removed or modified')
        }
        object.isLaunching = false
      });
    })
  },
  mounted() {
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 20px 10px;
  display: flex;
}

li a {
  text-decoration: none;
  color: #333;
}

.rooms {
  max-width: 800px;
  margin: 0 auto;
}

.rooms_formWrapper {
  border: 1px solid #ccc;
  border-radius: 20px;
  height: 40px;
  width: 80%;
  padding: 1px 20px;
  font-size: 17px;
  margin: 15px auto;
  text-align: left;
  background-color: #fff;
  position: relative;
}

.rooms_textField {
  height: 30px;
  margin: 0;
  padding: 5px 0;
  border: none;
  width: 85%;
  font-size: 17px;
  line-height: 1.7;
  resize: none;
  outline: none;
}

.rooms_form {
  height: 50px;
  background-color: #fff;
  margin-bottom: 20px;
}

.rooms_submit {
  position: absolute;
  right: 15px;
  bottom: 8px;
  font-weight: bold;
  color: #3293ff;
  background-color: #fff;
  font-size: 14px;
  border-radius: 0;
  -webkit-box-sizing: content-box;
  -webkit-appearance: button;
  appearance: button;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
}

.rooms_listItem {
}

.rooms_listItemLink {
  display: flex;
  align-items: center;
  width: 100%;
}

.rooms_listItem--left {
  width: 80%;
  display: flex;
  align-items: center;
}

.rooms_listItem--right {
  width: 20%;
}

.rooms_pic img {
  border-radius: 50%;
  width: 40px;
}

.rooms_limitTime {

}

.rooms_name {
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Rooms.vue